"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require('./vocabularyDefinition.module.css');const e="_vocab_1nye9_1",o={vocab:e};exports.default=o;exports.vocab=e;
//# sourceMappingURL=vocabularyDefinition.module.css.cjs.map
